/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Calendar",
  size: 20
}

const SvgCalendar = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M2 3v14h16V3H2zm15 13H3V8h14v8zm0-9H3V4h14v3z" />
    <path d="M6 2h1v3H6zM13 2h1v3h-1z" />
  </Svg>
)

SvgCalendar.defaultProps = defaultProps
export default SvgCalendar
